import { selectedAddress } from './ServiceAddress';
import util from '../lib/util';
const selectFormValue = (form, formValueName) => (form && form[formValueName]);
const getUserName = (state) => {
    let userName = '';
    if (state.gas.user) {
        const user = state.gas.user;
        userName = user.username;
        if (user.isSapLinked && !user.isSapError) {
            userName = user.isContractor ?
                user.companyName : user.firstName + ' ' + user.lastName;
        }
    }
    return userName;
};
const selectAddressString = (state) => {
    const p = selectedAddress(state);
    return util.addressToString(p);
};

export {
    selectFormValue,
    getUserName,
    selectAddressString,
};
